import { AccessibleIcon } from '@radix-ui/react-accessible-icon'
import React, { SVGProps } from 'react'

interface EyeOff extends SVGProps<SVGSVGElement> {
  label?: string
}

const EyeOff: React.FC<EyeOff> = ({ label = 'eyeOff', ...restProps }) => {
  return (
    <AccessibleIcon label={label}>
      <svg
        {...restProps}
        data-testid="eye-off-svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M3.76639 4.94506L1.16055 2.34006L2.33972 1.16089L18.8389 17.6609L17.6597 18.8392L14.9014 16.0809C13.4357 17.0105 11.7353 17.5028 9.99972 17.5001C5.50639 17.5001 1.76805 14.2667 0.983887 10.0001C1.34224 8.05899 2.31858 6.2858 3.76722 4.94506H3.76639ZM12.2972 13.4767L11.0772 12.2567C10.6106 12.48 10.0862 12.553 9.57633 12.4657C9.06646 12.3784 8.59622 12.1351 8.23045 11.7693C7.86467 11.4036 7.62136 10.9333 7.53407 10.4234C7.44677 9.91358 7.51979 9.38918 7.74305 8.92256L6.52305 7.70256C5.99282 8.5038 5.75578 9.46367 5.85208 10.4196C5.94838 11.3756 6.3721 12.2689 7.05149 12.9483C7.73088 13.6277 8.62418 14.0514 9.58015 14.1477C10.5361 14.244 11.496 14.007 12.2972 13.4767ZM6.64472 3.13339C7.68389 2.72506 8.81639 2.50006 9.99972 2.50006C14.4931 2.50006 18.2314 5.73339 19.0156 10.0001C18.7602 11.3881 18.1863 12.698 17.3389 13.8267L14.1222 10.6101C14.2178 9.9664 14.1612 9.30931 13.9572 8.69144C13.7531 8.07356 13.4071 7.51207 12.947 7.05195C12.4869 6.59182 11.9254 6.24587 11.3075 6.04178C10.6896 5.8377 10.0325 5.78117 9.38889 5.87672L6.64472 3.13422V3.13339Z"
          fill="currentColor"
        />
      </svg>
    </AccessibleIcon>
  )
}

export default EyeOff
